import Text from 'components/base/Text';
import {
  Flex,
  LegendSymbol,
  Margin,
  Padding
} from 'components/base/layout-components';
import _ from 'lodash';

export const LegendTooltip = ({ data = [] }) => {
  const maxValue = _.max(data.map(({ value }) => value)) || 0;
  const maxChars = maxValue.toString().length;

  return (
    <Padding padding='x-x-small' b='no-space'>
      {Object.values(data).map(({ title, value, color }, idx) => {
        if (value === 0) return false;

        return (
          <Flex key={idx} items='center' pb='x-small' data-testid='legend-item'>
            <Margin r='x-small'>
              {<LegendSymbol backgroundColor={color} />}
            </Margin>
            <Text
              size='small'
              mr='0.5rem'
              width={maxChars}
              ellipsisAfter={maxChars}
              align='end'
            >
              {value}
            </Text>
            <Text>{_.capitalize(title)}</Text>
          </Flex>
        );
      })}
    </Padding>
  );
};

export const WeekendWorkTooltip = () => {
  return (
    <Padding padding='small'>
      <Text size='x-large'>Weekend work detected</Text>
      <Text size='medium' pt='1rem' lineHeight='1.7rem'>
        Weekends are excluded from cycle time,
        <br />
        but they are taken into account in branch activity <br />
        to give you a precise overview of your work.
      </Text>
    </Padding>
  );
};
